<template>
	<b-card img-bottom :img-src="rec.Photos && rec.Photos.length?rec.Photos[0].thumbnails.large.url:null" border-variant="dark" class="my-4">
		<h5 slot="header" class="m-0 pointer" @click="inspect">{{rec['Title Name'][0]}}</h5>
		<p v-if="rec['Author Name'] && rec['Author Name'].length" class="text-small text-right font-weight-light font-italic py-0 my-0"><span v-for="(author, idx) in rec['Author Name']" @click="inspectAuthor(rec['Author'][idx])" class="pointer"> {{author + (idx===rec['Author Name'].length-1?'':' & ')}} </span></p>
		<p class="text-small text-right py-0 my-0">{{ rec['Dates'] }} in {{ rec['Year'] }} </p>
		<h6 class="text-strong my-0 mt-3" v-if="rec['Troupe Name'] && rec['Troupe Name'].length">Performed by {{ rec['Troupe Name'][0] }}</h6>
		<b-row v-if="rec['Cast Member Names'] && rec['Cast Member Names'].length">
			<b-col cols=12>
				<b-list-group flush>
					<b-list-group-item class="py-0 pointer" @click="inspectCastMember(rec['Cast Members'][idx])" v-for="(cm, idx) in rec['Cast Member Names']">
						<small>{{cm}}</small>
					</b-list-group-item>
				</b-list-group>
			</b-col>
		</b-row>
	</b-card>
</template>

<script>
export default {
	name: 'CardPerformance',
	props: [
		'rec'
	],
	methods: {
		inspect() {
			this.$store.dispatch('featured/inspect', {
				type: 'PERF',
				data: this.rec
			})
			this.$router.push({
				name: 'feature-performance',
				params: {
					id: this.rec.id,
				}
			})
		},
		inspectCastMember(cm) {
			this.$store.dispatch('featured/load', {
				type: 'CAST',
				id: cm
			})
			this.$router.push({
				name: 'feature-member',
				params: {
					id: cm,
				}
			})
		},
		inspectAuthor(author) {
			this.$store.dispatch('featured/load', {
				type: 'AUTHOR',
				id: author
			})
			this.$router.push({
				name: 'feature-author',
				params: {
					id: author,
				}
			})
		}
	}
}
</script>
